module.exports = __webpack_public_path__ + "img/支架-场景11.2@2x.ea7ef847.png";